import React, { StrictMode } from "react";
import * as Sentry from "@sentry/react";
import clarity from "@microsoft/clarity";
import { createRoot } from "react-dom/client";

import { isProduction } from "./helpers";
import { App } from "./App";

Sentry.init({
  dsn: "https://72bd92e2f7b1eaf163677e6c7f9aee99@o4510062826029056.ingest.de.sentry.io/4510062837235792",
  environment: import.meta.env.VITE_ENVIRONMENT,
  enabled: import.meta.env.VITE_BUILD_NUMBER !== undefined,
});

if (isProduction()) {
  clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
